import React from 'react';
import { useTranslation } from 'react-i18next';

const ContactView = () => {
    const { t } = useTranslation();
    const styles = {
        container: { padding: '30px', maxWidth: '800px', margin: '0 auto', textAlign: 'center' },
        title: { borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '40px' },
        contactInfo: { marginBottom: '40px' },
        infoLine: { marginBottom: '15px', fontSize: '1.1em' }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>{t('contact_title')}</h2>
            
            <div style={styles.contactInfo}>
                <p>{t('contact_intro')}</p>
                
                <div style={styles.infoLine}>
                    <strong>Email :</strong> <a href="mailto:contact@medapp-solution.com">contact@medapp-solution.com</a>
                </div>
                
                <div style={styles.infoLine}>
                    <strong>{t('contact_support')} :</strong> <a href="mailto:support@medapp-solution.com">support@medapp-solution.com</a>
                </div>
            </div>

            <p>{t('contact_response')}</p>
        </div>
    );
};

export default ContactView;
